// import { CompareActionConfig, useComparableBoats } from '@app/hooks/useCompare';
// import styles from '@styles/CompareBoats/index.module.scss';
'use client';
import { AntMessageProvider } from 'providers/src/AntMessageProvider';
import { AntNotificationProvider } from 'providers/src/AntNotificationProvider';
import React, { useEffect, useState } from 'react';
import { BoatGalleryModal } from './BoatGalleryModal';
import styles from './CompareBoats.module.scss';
import { CompareCarousel } from './CompareCarousel';
import { CompareSearchPanel } from './CompareSearchPanel';
import { CompareTable } from './CompareTable/index';

const CompareBoats: React.FC = () => {
  const [isHydrates, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <AntMessageProvider>
      <AntNotificationProvider>
        <div className={styles.container}>
          {isHydrates ? (
            <>
              <BoatGalleryModal />
              <div className={styles.headerWrapper}>
                <div className={styles.header}>
                  <CompareSearchPanel />
                  <CompareCarousel />
                </div>
              </div>
              <div className={styles.tableWrapper}>
                {/* <CompareCarousel /> */}

                <CompareTable />
              </div>
            </>
          ) : (
            <p>Loading...</p>
          )}

          {/* <BackTop /> */}
        </div>
      </AntNotificationProvider>
    </AntMessageProvider>
  );
};

export default CompareBoats;
